import {OrderButtonsMoveDown} from './components/order-buttons-move-down';
import {OrderButtonsMoveUp} from './components/order-buttons-move-up';
import {OrderButtonsRoot} from './components/order-buttons-root';

export const OrderButtons = {
	Root: OrderButtonsRoot,
	MoveUp: OrderButtonsMoveUp,
	MoveDown: OrderButtonsMoveDown,
};
